export default {
  'biz': '@:terms.biz',
  'info': '@:terms.info',
  'input': '@:terms.input',
  'message': {
    'title': ['회사명 혹은 사업자등록번호로', '회사 정보를 검색해주세요.'],
  },
  'biz-name': '@:terms.biz-name',
  'biz-registration-number': '@:terms.business-operator@:terms.registration-number',
  'corporate-registration-number': '@:terms.corporate@:terms.registration-number',
  'owner': '대표자',
  'owner-name': '@:pages.sign-up.biz.owner 성명',
  'registration-number': '주민@:terms.registration-number',
  'owner-registration-number': '@:pages.sign-up.biz.owner @:pages.sign-up.biz.registration-number',
  'phone-number': '@:terms.phone-number',
  'biz-phone-number': '사업장 @:terms.phone-number',
  'biz-owner-phone-number': '회사 대표 @:terms.phone-number',
  'email': '@:terms.email',
  'owner-email': '@:pages.sign-up.biz.owner @:terms.email',
  'search': '@:terms.search하기',
  'placeholder': {
    'search': '회사명 or 사업자 등록번호',
    'biz-name': '예) 회사명',
    'owner-name': '예) 이혜움',
    'biz-registration-number': '예) 1234512345',
    'corporate-registration-number': '예) 1234561234567',
    'owner-registration-number': '예) 8201151012345',
    'biz-phone-number': '예) 01012341234',
    'owner-email': '예) heum@heumlabs.io',
  },
  'verification': {
    'required': {
      'biz-name': '@:terms.biz-name을 입력해주세요.',
      'biz-registration-number': '@:pages.sign-up.biz.biz-registration-number를 입력해주세요.',
      'corporate-registration-number': '@:pages.sign-up.biz.corporate-registration-number를 ' +
        '입력해주세요.',
      'owner-name': '@:pages.sign-up.biz.owner-name을 입력해주세요.',
      'registration-number': '@:pages.sign-up.biz.registration-number를 입력해주세요.',
      'biz-phone-number': '@:pages.sign-up.biz.biz-phone-number를 입력해주세요.',
      'owner-email': '@:pages.sign-up.biz.owner-email을 입력해주세요.',
    },
    'format': {
      'biz-registration-number': '@:pages.sign-up.biz.biz-registration-number형식에 맞게 입력해주세요.',
      'corporate-registration-number': '@:pages.sign-up.biz.corporate-registration-number형식에' +
        '맞게 입력해주세요.',
      'biz-phone-number': '@:pages.sign-up.biz.biz-phone-number형식에 맞게 입력해주세요.',
      'registration-number': '@:pages.sign-up.biz.registration-number형식에 맞게 입력해주세요.',
      'owner-email': '@:terms.email형식에 맞게 입력해주세요.',
    },
    'duplicated': {
      'biz-registration-number': '이미 @:terms.keep-kr에 @:terms.register된 @:terms.biz-no입니다.'
    }
  },
  'confirm': '@:terms.confirm',
  'ok': '@:terms.confirm',
  'close': '닫기',
  'error': {
    'create': '회사 정보를 저장하는데 실패하였습니다.',
    'companies': '회사 목록을 불러오는데 실패하였습니다.',
  },
}
